/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Prepared_Action_InvalidInputs */

const en_error_prepared_action_invalid = /** @type {(inputs: Error_Prepared_Action_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action cannot be run: ask Claude to prepare it again.`)
};

/**
* | output |
* | --- |
* | "This action cannot be run: ask Claude to prepare it again." |
*
* @param {Error_Prepared_Action_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_prepared_action_invalid = /** @type {((inputs?: Error_Prepared_Action_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Prepared_Action_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_prepared_action_invalid(inputs)
});